// src/services/tokenDoPainel.js -- renova o token FCM ao ABRIR o painel.
//
// Por que existe. Ate 12/09/2026 o dashboard so reenviava o valor guardado no
// navegador (`getCookie('fcm-token')`, que na verdade e' localStorage). Isso
// falha nos dois casos mais comuns:
//
//   localStorage limpo  -> nao havia valor, nenhum POST saia, e o operador
//                          ficava sem canal EM SILENCIO.
//   token rotacionado   -> reenviava a string velha; o backend a ressuscitava
//                          com active=True e o FCM a recusava no envio seguinte.
//                          Ficava piscando entre viva e morta, sem nunca entregar.
//
// Sem isto, a unica cura era o operador achar o sininho e reativar na mao.
//
// Por que chamar `getToken` aqui e' seguro. O SDK do Firebase registra o proprio
// service worker em `/firebase-cloud-messaging-push-scope` e assina no PushManager
// DAQUELE registro; a nossa assinatura VAPID vive no registro de escopo `/`
// (`webPush.js` usa `navigator.serviceWorker.ready`). Sao dois PushManager
// distintos: um nao derruba o outro. O comentario antigo que dizia o contrario
// descrevia o commit `cee7d23`, que unificava os registros e foi REVERTIDO em
// 12/09/2026 justamente porque a disputa pela vaga tirava o push de 1 em 3
// aparelhos.
//
// Exemplo:
//   await renovarTokenDoPainel({ http: api, deviceId, messaging, getToken, chave });

/** `Notification` nao existe no node do teste; por isso a funcao e nao um default direto. */
function notificacaoDoNavegador() {
  return typeof Notification === 'undefined' ? undefined : Notification;
}

/** Sem permissao concedida nao ha o que renovar -- e `getToken` abriria pop-up. */
function podeRenovar(notificacao) {
  return typeof notificacao !== 'undefined' && notificacao.permission === 'granted';
}

/**
 * Pega o token ATUAL do Firebase e o registra no backend. Devolve o token, ou
 * `null` quando nao havia o que fazer. NUNCA rejeita: o boot do painel nao pode
 * depender do push.
 *
 * `getToken` so abre pop-up quando a permissao esta em `default`; com `granted`
 * ele resolve direto. Por isso a guarda acima e' obrigatoria.
 */
export async function renovarTokenDoPainel({
  http, deviceId, messaging, getToken, chave, notificacao = notificacaoDoNavegador(),
}) {
  if (!podeRenovar(notificacao)) return null;
  try {
    const token = await getToken(messaging, { vapidKey: chave });
    if (!token) return null;
    await http.post('/dashboard/api/fcm-token/', { token, device_id: deviceId || null });
    return token;
  } catch (erro) {
    console.warn(JSON.stringify({ evento: 'token_do_painel_falhou', erro: String(erro) }));
    return null;
  }
}
